import produce from 'immer';
import margeById from '../../../../helpers/margeById';

export const actions = {
  GET_ARTISAN_PRIVATE_INQUIREY: 'GET_ARTISAN_PRIVATE_INQUIREY',
  GET_ARTISAN_PRIVATE_INQUIREY_SUCCESS: 'GET_ARTISAN_PRIVATE_INQUIREY_SUCCESS',

  GET_ARTISAN_PRIVATE_INQUIRIES: 'GET_ARTISAN_PRIVATE_INQUIRIES',
  GET_ARTISAN_PRIVATE_INQUIRIES_SUCCESS:
    'GET_ARTISAN_PRIVATE_INQUIRIES_SUCCESS',
     GET_ARTISAN_PRIVATE_INQUIRIES: 'GET_ARTISAN_PRIVATE_INQUIRIES',
  GET_ARTISAN_PRIVATE_INQUIRIES_SUCCESS:
    'GET_ARTISAN_PRIVATE_INQUIRIES_SUCCESS',
  GET_ARTISAN_PRIVATE_STAGING_INQUIRIES_SUCCESS:
    'GET_ARTISAN_PRIVATE_STAGING_INQUIRIES_SUCCESS',
  GET_ARTISAN_PRIVATE_STAGING_INQUIRIES:
    'GET_ARTISAN_PRIVATE_STAGING_INQUIRIES',
  ARTISAN_PRIVATE_INQUIREY_IS_LOADING: 'ARTISAN_PRIVATE_INQUIREY_IS_LOADING',

  DELETE_PRIVATE_ARTISAN_INQUIRY: 'DELETE_PRIVATE_ARTISAN_INQUIRY',
  DELETE_PRIVATE_ARTISAN_INQUIRY_SUCCESS:
    'DELETE_PRIVATE_ARTISAN_INQUIRY_SUCCESS',
  EDIT_PRIVATE_ARTISAN_INQUIRY: 'EDIT_PRIVATE_ARTISAN_INQUIRY',
  EDIT_PRIVATE_ARTISAN_INQUIRY_SUCCESS: 'EDIT_PRIVATE_ARTISAN_INQUIRY_SUCCESS',

  ADD_PRIVATE_ARTISAN_INQUIRY: 'ADD_PRIVATE_ARTISAN_INQUIRY',
  ADD_PRIVATE_ARTISAN_INQUIRY_SUCCESS: 'ADD_PRIVATE_ARTISAN_INQUIRY_SUCCESS',

  SET_PRIVATE_ARTISAN_INQUIRY_COUNT: 'SET_PRIVATE_ARTISAN_INQUIRY_COUNT',
  SET_PRIVATE_STAGING_ARTISAN_INQUIRY_COUNT: 'SET_PRIVATE_STAGING_ARTISAN_INQUIRY_COUNT',
};

const initalState = {
  items: [],
  staging: [],
  isLoading: false,
  count: 0,
  stagingCount: 0,
  searchValue: '',
};

export default produce((draft, action) => {
  if (!draft) return initalState;

  const { type, payload } = action;

  switch (type) {
    case actions.GET_ARTISAN_PRIVATE_INQUIREY_SUCCESS: {
      const currentItems = draft.items;
      draft.items = margeById(currentItems, [payload]);
      break;
    }

    case actions.GET_ARTISAN_PRIVATE_INQUIRIES_SUCCESS: {
      const currentItems = draft.items;
      draft.items = margeById(currentItems, payload);
      break;
    }
    case actions.GET_ARTISAN_PRIVATE_STAGING_INQUIRIES_SUCCESS: {
      const currentItems = draft.staging;
      draft.staging = margeById(currentItems, payload);
      break;
    }

    case actions.ARTISAN_PRIVATE_INQUIREY_IS_LOADING: {
      draft.isLoading = payload;
      break;
    }
    case actions.DELETE_PRIVATE_ARTISAN_INQUIRY_SUCCESS: {
      draft.items = draft.items.filter((item) => item._id !== payload);
      break;
    }
    case actions.EDIT_PRIVATE_ARTISAN_INQUIRY_SUCCESS: {
      const updatedPrivateInquiry = payload;
      const targetIndex = draft.staging.findIndex(
        (tag) => tag._id === updatedPrivateInquiry._id
      );
      draft.items[targetIndex] = updatedPrivateInquiry;
      break;
    }
    case actions.SET_PRIVATE_ARTISAN_INQUIRY_COUNT: {
      draft.count = payload;
      break;
    }
     case actions.SET_PRIVATE_STAGING_ARTISAN_INQUIRY_COUNT: {
      draft.stagingCount = payload;
      break;
    }
 
    case actions.ADD_PRIVATE_ARTISAN_INQUIRY_SUCCESS: {
      const currentPrivateInquiry = draft.staging;
      draft.staging = margeById(currentPrivateInquiry, [payload]);
      break;
    }
  }
});
